import React from 'react';


const Star = ({ fill, size = 24 }) => {
	const fillPercentage = Math.min(Math.max(fill, 0), 1) * 100;
	const gradientId = `star-fill-${Math.random().toString(36).substr(2, 9)}`;

	return (
		<div style={{ width: size, height: size }}>
			<svg
				viewBox="0 0 24 24"
				fill="none"
				stroke="#b31d15"
				strokeWidth="0.8"
				strokeLinecap="round"
				strokeLinejoin="round"
				style={{ width: '100%', height: '100%' }}
			>
				<defs>
					<linearGradient id={gradientId}>
						<stop offset="0%" stopColor="#b31d15" />
						<stop offset={`${fillPercentage}%`} stopColor="#b31d15" />
						<stop offset={`${fillPercentage}%`} stopColor="transparent" />
					</linearGradient>
				</defs>
				<path
					fill={`url(#${gradientId})`}
					d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27
          5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"
				/>
			</svg>
		</div>
	);
};

export default Star;
